import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./status.module.scss";

export function WaitingDeliveryStatus() {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="waiting"
      Lefticon={<img src="../../../assets/images/svg/shipping.svg" />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_waiting_shipping_contract_status_title")}
      </p>
    </Pill>
  );
}
